<template>
  <div class="inner-banner">
    <section class="w3l-breadcrumb">
      <div class="container">
        <h4 class="inner-text-title font-weight-bold text-white mb-sm-3 mb-2">{{ title }}</h4>
        <ul class="breadcrumbs-custom-path">
          <li><router-link to="/">Home</router-link></li>
          <li class="active"><span class="fa fa-chevron-right mx-2" aria-hidden="true"></span>{{ currentPage }}</li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'InnerBanner',
  props: {
    title: {
      type: String,
      required: true
    },
    currentPage: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>


.w3l-breadcrumb {
  position: relative;
  z-index: 1;
}

.breadcrumbs-custom-path {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
}

.breadcrumbs-custom-path li {
  color: #fff;
}

.breadcrumbs-custom-path li a {
  color: #fff;
  text-decoration: none;
}

.breadcrumbs-custom-path li.active {
  color: #fff;
}
</style> 